import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

function TopBanner() {
  const navigate = useNavigate();
  return (
    <Conatiner
      onClick={() => navigate('/promotion/땅집고옥션-얼리버드-이벤트')}
    >
      <img
        src="/assets/images/banner/banner_coupon.svg"
        alt="coupon"
        width={'50px'}
      />
      <Title>지금 멤버십 구매 시 50%할인!</Title>
    </Conatiner>
  );
}

export default TopBanner;

const Conatiner = styled.div`
  width: 100%;
  height: 40px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background: #17171c;
  gap: 12px;
  cursor: pointer;
`;

const Title = styled.div`
  font-weight: 700;
  font-size: 16px;
  line-height: 145%;
  letter-spacing: -2%;
  color: white;
`;
